<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">Referral for Testing</h2>

        <ul class="list-disc pl-4  font-light">
            <li>
                At the age of 13, due to the patient’s presenting symptoms and the patient’s medical and family history of recurrent kidney stones and kidney issues, <span class="font-semibold">ESKD was suspected</span>
            </li>
            <li>
                The patient also had a <span class="font-semibold">history of elevated oxalate levels</span>
                <ul class="list-inside list-['-_'] pl-6">
                    <li>The patient had elevated urinary oxalate (579 mmol/L) at age 4 years</li>
                    <li>No history was suggestive of enteric hyperoxaluria, with no excessive intake of vitamin C, oxalate-rich diet, or evidence of chronic malabsorption</li>
                </ul>
            </li>
            <li>
                <span class="font-semibold">He was referred for diagnostic tests</span>
                <ul class="list-inside list-['-_'] pl-6">
                    <li>The patient had his laboratory values assessed</li>
                    <li>He was also referred for ultrasound and CT scans</li>
                </ul>
            </li>
            <li>
                After subsequent diagnosis of ESKD and considering the history of elevated oxalate levels, <span class="font-semibold">PH1 was suspected</span>,  and he was referred for confirmatory genetic testing
            </li>
        </ul>
    </div>
</template>
